<template>
  <v-dialog v-model="showEventDialog" max-width="1000">
    <v-flex xs12 class="dialogActivitiesSelecter">
      <v-layout column>
        <v-flex>
          <v-layout row class="ml-2 pt-4">
            <v-icon
              class="ml-4"
              :style="`color: ${$vuetify.theme.primary}`"
              large
              >format_list_bulleted</v-icon
            >
            <h1 :style="`color: ${$vuetify.theme.primary}`" class="ml-3">
              {{ $translate("SELECT_PICKUP_DELIVERY_EVENTS") }}
            </h1>
          </v-layout>
        </v-flex>

        <v-flex>
          <v-layout class="listOutline" justify-center row>
            <v-flex xs4>
              <h2 color="secondary">{{ $translate("ALL_EVENTS") }}</h2>
              <v-layout column>
                <v-flex class="elevation-1 cardEvents">
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in possibleRelatedEventsList"
                      :key="index"
                      @click=""
                    >
                      <v-list-tile-action>
                        <v-checkbox
                          class="ml-2 mt-4"
                          v-model="item.Selected"
                          @change="cbLeftClicked(index)"
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content
                        class="listOutlineSubUserGroupDialog"
                        @click="addElementToAvailable(index)"
                      >
                        <v-list-tile-title>{{ item.Name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          item.Type
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- Left and Right arrows -->
            <v-flex xs2>
              <v-layout align-center justify-center column>
                <v-flex>
                  <v-btn
                    :disabled="eventsSelectedFromPossibleList.length === 0"
                    round
                    color="primary"
                    class="mb-4 mr-5 text-capitalize"
                    @click="addToSelected"
                  >
                    <v-icon large>arrow_forward</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex>
                  <v-btn
                    :disabled="eventsSelectedFromToBeSavedList.length === 0"
                    round
                    color="secondary"
                    class="mr-5 text-capitalize"
                    @click="removeFromSelected"
                  >
                    <v-icon large>arrow_back</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout class="layoutForRightCard" justify-center column>
                <h2 color="secondary">
                  {{ $translate("SELECTED_PICKUP_DELIVERY_EVENTS") }}
                </h2>
                <div class="elevation-1 cardEvents">
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in relatedEventsToBeSavedList"
                      :key="index"
                      @click=""
                    >
                      <v-list-tile-action>
                        <v-checkbox
                          class="ml-2 mt-4"
                          v-model="item.Selected"
                          @change="cbRightClicked(index)"
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content
                        class="listOutlineSubUserGroupDialog"
                        @click="addElementToSelected(index)"
                      >
                        <v-list-tile-title>{{ item.Name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          item.Type
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex>
          <v-layout class="my-4 mr-4" align-end justify-end row>
            <v-btn
              round
              color="secondary"
              class="text-capitalize"
              @click="cancelChanges"
              >{{ $translate("CANCEL") }}</v-btn
            >
            <v-btn
              round
              color="primary"
              class="text-capitalize"
              @click="saveChanges"
              >{{ $translate("DONE") }}</v-btn
            >
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-dialog>
</template>

<script>
export default {
  name: "RelatedEventsDialog",
  props: {
    showDialog: Boolean,
    possibleRelatedEvents: Array,
    relatedEventsToBeSaved: Array,
  },
  computed: {
    showEventDialog() {
      return this.showDialog;
    }
  },
  watch: {},
  data() {
    return {
      possibleRelatedEventsList: [],
      relatedEventsToBeSavedList: [],
      eventsSelectedFromPossibleList: [],
      eventsSelectedFromToBeSavedList: [],
    };
  },
  mounted() {
    this.possibleRelatedEvents.forEach(
      event => {
        let tmpObj = Object.assign({}, event);
        this.possibleRelatedEventsList.push(tmpObj);
      }
    );

    this.relatedEventsToBeSaved.forEach(
      event => {
        let tmpObj = Object.assign({}, event);
        this.relatedEventsToBeSavedList.push(tmpObj);
      }
    );

    // Add 'Selected' flag to initial data
    if (this.possibleRelatedEventsList !== undefined) {
      this.possibleRelatedEventsList.forEach(
        (event) => (event.Selected = false)
      );
    }

    if (this.relatedEventsToBeSavedList !== undefined) {
      this.relatedEventsToBeSavedList.forEach(
        (event) => (event.Selected = false)
      );
    }

    console.log("possibleRelatedEventsList: ", this.possibleRelatedEventsList);
    console.log(
      "relatedEventsToBeSavedList: ",
      this.relatedEventsToBeSavedList
    );
  },
  methods: {
    cbLeftClicked(index) {
      // Called when the check box in the possible related events list is clicked on
      // Either remove or add selected user role to the list
      this.updateLeftSelection(index);
    },
    addElementToAvailable(index) {
      this.possibleRelatedEventsList[index].Selected = !this
        .possibleRelatedEventsList[index].Selected;

      console.log("possibleRelatedEventsList after clicking on index: ", index, this.possibleRelatedEventsList);
      this.updateLeftSelection(index);
    },
    updateLeftSelection(index) {
      const i = this.eventsSelectedFromPossibleList.findIndex(
        (event) =>
          event.EventId === this.possibleRelatedEventsList[index].EventId
      );
      if (i > -1) {
        this.eventsSelectedFromPossibleList.splice(i, 1);
      } else {
        this.eventsSelectedFromPossibleList.push(
          this.possibleRelatedEventsList[index]
        );
      }

      console.log("eventsSelectedFromPossibleList: ", this.eventsSelectedFromPossibleList);
    },
    cbRightClicked(index) {
      // Called when the check box in the personal user role list is clicked on
      // Either remove or add selected user role to the list
      this.updateRightSelection(index);
    },
    addElementToSelected(index) {
      this.relatedEventsToBeSavedList[index].Selected = !this
        .relatedEventsToBeSavedList[index].Selected;
      this.updateRightSelection(index);
    },
    updateRightSelection(index) {
      const i = this.eventsSelectedFromToBeSavedList.findIndex(
        (event) =>
          event.EventId === this.relatedEventsToBeSavedList[index].EventId
      );
      if (i > -1) {
        this.eventsSelectedFromToBeSavedList.splice(i, 1);
      } else {
        this.eventsSelectedFromToBeSavedList.push(
          this.relatedEventsToBeSavedList[index]
        );
      }

      console.log("eventsSelectedFromToBeSavedList: ", this.eventsSelectedFromToBeSavedList);
    },
    addToSelected() {
      this.eventsSelectedFromPossibleList.forEach((e) => {
        e.Selected = false;
        this.relatedEventsToBeSavedList.push(e);
        const index = this.possibleRelatedEventsList.findIndex(
          (i) => i.EventId == e.EventId
        );
        this.possibleRelatedEventsList.splice(index, 1);
      });
      this.eventsSelectedFromPossibleList = [];
    },
    removeFromSelected() {
      this.eventsSelectedFromToBeSavedList.forEach((e) => {
        e.Selected = false;
        this.possibleRelatedEventsList.push(e);
        const index = this.relatedEventsToBeSavedList.findIndex(
          (i) => i.EventId == e.EventId
        );
        this.relatedEventsToBeSavedList.splice(index, 1);
      });
      this.eventsSelectedFromToBeSavedList = [];
    },
    resetDialog() {
      this.eventsSelectedFromPossibleList = [];
      this.eventsSelectedFromToBeSavedList = [];
    },
    cancelChanges() {
      this.resetDialog();
      this.$emit("cancel-changes");
    },
    saveChanges() {
      this.resetDialog();
      this.$emit("save-changes", this.relatedEventsToBeSavedList);
    },
  },
};
</script>

<style>
.dialogActivitiesSelecter {
  background-color: #ffffff;
  border-radius: 1em;
}
.cardEvents {
  margin-right: 1em;
  border: 1.5px solid black;
  min-height: 30em;
  max-height: 30em;
  max-width: 20em !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.listOutline {
  margin-top: 1em;
  margin-left: 2.6em;
}
.listOutlineSubUserGroupDialog {
  border-bottom: 1px solid black;
  text-overflow: ellipsis;
}
</style>
